module.exports = __webpack_public_path__ + "media/images/icons/outlined/camera-0ddb717b372f2ac0b329e130a0da0443.svg";